module["exports"] = ["Південний", "Північний", "Східний", "Західний"];